export default __webpack_public_path__ + "static/media/no-data-error.700c9b69.svg";